/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Vllm_Model_NameInputs */



/**
* | output |
* | --- |
* | "Model at the endpoint" |
*
* @param {Private_Models_Form_Vllm_Model_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_vllm_model_name = /** @type {((inputs?: Private_Models_Form_Vllm_Model_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Vllm_Model_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Modell am Endpunkt")
	return /** @type {LocalizedString} */ ("Model at the endpoint")
});